@if (showBanner()) {
  <div class="fixed bottom-0 left-0 right-0 z-50 p-4 pb-[max(1rem,env(safe-area-inset-bottom))]">
    <div class="max-w-lg mx-auto bg-white rounded-2xl shadow-[0_8px_32px_rgba(22,38,63,0.18)] border border-[#ebeef2] overflow-hidden">
      <div class="flex items-center gap-4 px-4 py-3.5">

        <!-- Icon -->
        <img src="icon-192.png" alt="App-Icon" class="w-12 h-12 rounded-[13px] shrink-0 shadow-sm" />

        <!-- Text -->
        <div class="flex-1 min-w-0">
          <p i18n="@@pwa.banner.title" class="text-[13.5px] font-bold text-[#16263f] leading-tight">Zum Homebildschirm hinzufügen</p>
          @if (isIos()) {
            <p class="text-[12px] text-[#5a6b80] mt-0.5 leading-snug">
              <span i18n="@@pwa.banner.ios.before">Tippe auf</span>
              <svg class="inline-block w-3.5 h-3.5 mx-0.5 align-text-bottom text-[#294f7d]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/>
                <polyline points="16 6 12 2 8 6"/>
                <line x1="12" y1="2" x2="12" y2="15"/>
              </svg>
              <span i18n="@@pwa.banner.ios.after">und dann „Zum Home-Bildschirm"</span>
            </p>
          } @else {
            <p i18n="@@pwa.banner.android.hint" class="text-[12px] text-[#5a6b80] mt-0.5">Als App auf dem Homescreen speichern</p>
          }
        </div>

        <!-- Buttons -->
        @if (!isIos()) {
          <button
            (click)="install()"
            i18n="@@pwa.banner.install"
            class="shrink-0 px-4 py-2 rounded-[10px] bg-[#16263f] text-white text-[13px] font-semibold hover:opacity-90 transition-opacity cursor-pointer"
          >Hinzufügen</button>
        }
        <button
          (click)="dismiss()"
          class="shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-[#7c8a9d] hover:bg-[#f5f6f8] transition-colors cursor-pointer"
          aria-label="Schließen"
          i18n-aria-label="@@pwa.banner.close"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>

      </div>
    </div>
  </div>
}
